import classnames from "classnames";
import React, { FC, MouseEvent } from "react";
import { Oval } from "react-loader-spinner";

interface Props {
  children?: React.ReactNode;
  className?: string;
  fontSize?: "xs" | "sm" | "base" | "lg";
  borderRadius?: "none" | "lg" | "xl" | "full";
  borderWidth?: string;
  borderColor?: string;
  bgColor?: string;
  textColor?: string;
  type?: "button" | "submit";
  onClick?: (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => void;
  disabled?: boolean;
  form?: string;
  isSubmitting?: boolean;
}

export const Button: FC<Props> = ({
  children,
  className,
  onClick = undefined,
  disabled = false,
  borderRadius = "none",
  bgColor = "bg-primary",
  borderColor = "border-transparent",
  fontSize = "sm",
  textColor = "white",
  type = "button",
  isSubmitting,
  ...rest
}) => {
  return (
    <button
      {...rest}
      type={type}
      onClick={onClick}
      disabled={disabled || isSubmitting}
      className={classnames(
        `${className} flex items-center justify-center leading-snug space-x-3 rounded-${borderRadius} ${
          disabled ? "bg-gray-500" : bgColor
        } text-${fontSize} text-${disabled ? "gray-300" : textColor} border ${borderColor}`,
        {
          "bg-opacity-40 cursor-not-allowed": disabled || isSubmitting
        }
      )}
    >
      {isSubmitting ? <Oval width={15} height={15} strokeWidth={5} color="#fff" /> : children}
    </button>
  );
};
